export const getCssBackgroundImage = (imageUrl) => {
  if (!imageUrl) return undefined;
  const escapedUrl = imageUrl.replace(/"/g, '%22');
  return `url("${escapedUrl}")`;
};

